import { defineMessages } from 'react-intl';

export default defineMessages({
    underwritingIssues: {
        id: 'e1p.gateway.views.cancellation-documents.Underwriting Issues',
        defaultMessage: 'Underwriting Issues'
    },
    longDescription: {
        id: 'e1p.gateway.views.endorsement-documents.Long Description',
        defaultMessage: 'Long Description'
    },
    shortDescription: {
        id: 'e1p.gateway.views.endorsement-documents.Short Description',
        defaultMessage: 'Short Description'
    },
    noOpenUnderwritingSubmission: {
        id: 'e1p.gateway.views.job-uwissues.There are no underwriting issues associated with this.Submission',
        defaultMessage: 'There are no open underwriting issues associated with this quote.'
    },
    noOpenUnderwritingPolicyChange: {
        id: 'e1p.gateway.views.job-uwissues.There are no underwriting issues associated with this.PolicyChange',
        defaultMessage: 'There are no open underwriting issues associated with this policy change.'
    },
    noOpenUnderwritingRenewal: {
        id: 'e1p.gateway.views.job-uwissues.There are no underwriting issues associated with this.Renewal',
        defaultMessage: 'There are no open underwriting issues associated with this renewal.'
    },
    underwritingCustom: {
        id: 'e1p.quoteandbind.views.quote-details.Custom',
        defaultMessage: 'Custom'
    },
    withDrawJOB: {
        id: 'e1p.gateway.views.quote-uwissues.Withdraw',
        defaultMessage: 'Withdraw'
    },
    reasonCancellation: {
        id: 'e1p.gateway.views.job-uwissues.this job and select a reason for the cancellation.',
        defaultMessage: 'this job and select a reason for the cancellation.'
    },
    cancelQuote: {
        id: 'e1p.gateway.views.quote-uwissues.Cancel',
        defaultMessage: 'Cancel'
    },
    reasonContinue: {
        id: 'e1p.gateway.views.job-uwissues.this job if you do not wish to continue.',
        defaultMessage: 'this job if you do not wish to continue.'
    },
    confirmJob: {
        id: 'e1p.gateway.views.job-uwissues.Confirm',
        defaultMessage: 'Confirm'
    },
    jobStatusUW: {
        id: 'e1p.gateway.views.job-uwissues.Status',
        defaultMessage: 'Status'
    },
    cancelJob: {
        id: 'e1p.gateway.views.job-uwissues.Cancel',
        defaultMessage: 'Cancel'
    },
    toCompletePointersForSubmission: {
        id: 'e1p.gateway.views.job-uwissues.You cannot complete this.You cannot complete this Submission until these issues have been resolved. You can do the following',
        defaultMessage: 'You cannot complete this quote until these issues have been resolved. You can do the following:'
    },
    editSubmission: {
        id: 'e1p.gateway.views.job-uwissues.Edit the Submission if the customer is willing to accept the changes',
        defaultMessage: 'Edit the quote if the customer is willing to accept the changes.'
    },
    reviewSubmission: {
        id: 'e1p.gateway.views.job-uwissues.Refer the Submission to an underwriter for review',
        defaultMessage: 'Refer the quote to an underwriter for review.'
    },
    reviewPolicyChange: {
        id: 'e1p.gateway.views.job-uwissues.Refer the PolicyChange to an underwriter for review',
        defaultMessage: 'Refer the policychange to an underwriter for review.'
    },
    reviewRenewal: {
        id: 'e1p.gateway.views.job-uwissues.Refer the Renewal to an underwriter for review',
        defaultMessage: 'Refer the renewal to an underwriter for review.'
    },
    reviewCancellation: {
        id: 'e1p.gateway.views.job-uwissues.Refer the Cancellation to an underwriter for review',
        defaultMessage: 'Refer the cancellation to an underwriter for review.'
    },
    warningEditSubmission: {
        id: 'e1p.gateway.views.job-uwissues.Edit Submission',
        defaultMessage: 'Edit quote'
    },
    warningEditRenewal: {
        id: 'e1p.gateway.views.job-uwissues.Edit Renewal',
        defaultMessage: 'Edit renewal'
    },
    warningEditPolicyChange: {
        id: 'e1p.gateway.views.job-uwissues.Edit PolicyChange',
        defaultMessage: 'Edit policy change'
    },
    warningEditCancellation: {
        id: 'e1p.gateway.views.job-uwissues.Edit Cancellation',
        defaultMessage: 'Edit cancellation'
    },
    warningUnderwriter: {
        id: 'e1p.gw-portals-policytransaction-common-angular.components.paymentWithPaymentPlan.payment.Refer to Underwriter',
        defaultMessage: 'Refer to Underwriter'
    },
    underwriterSubmission: {
        id: 'e1p.gateway.views.job-uwissues.Underwriting issues have been raised for this Submission',
        defaultMessage: 'Underwriting issues have been raised for this quote.'
    },
    underwriterPolicyChange: {
        id: 'e1p.gateway.views.job-uwissues.Underwriting issues have been raised for this PolicyChange',
        defaultMessage: 'Underwriting issues have been raised for this policy change.'
    },
    underwriterRenewal: {
        id: 'e1p.gateway.views.job-uwissues.Underwriting issues have been raised for this Renewal',
        defaultMessage: 'Underwriting issues have been raised for this renewal.'
    },
    underwriterCancellation: {
        id: 'e1p.gateway.views.job-uwissues.Underwriting issues have been raised for this Cancellation',
        defaultMessage: 'Underwriting issues have been raised for this cancellation.'
    },
    toCompletePointersForPolicyChange: {
        id: 'e1p.gateway.views.job-uwissues.You cannot complete this.You cannot complete this PolicyChange until these issues have been resolved. You can do the following',
        defaultMessage: 'You cannot complete this policy change until these issues have been resolved. You can do the following:'
    },
    toCompletePointersForRenewal: {
        id: 'e1p.gateway.views.job-uwissues.You cannot complete this.You cannot complete this Renewal until these issues have been resolved. You can do the following',
        defaultMessage: 'You cannot complete this renewal until these issues have been resolved. You can do the following:'
    },
    toCompletePointersForCancellation: {
        id: 'e1p.gateway.views.job-uwissues.You cannot complete this.You cannot complete this Cancellation until these issues have been resolved. You can do the following',
        defaultMessage: 'You cannot complete this cancellation until these issues have been resolved. You can do the following:'
    },
    editPolicyChange: {
        id: 'e1p.gateway.views.job-uwissues.Edit the PolicyChange if the customer is willing to accept the changes',
        defaultMessage: 'Edit the policy change if the customer is willing to accept the changes.'
    },
    editRenewal: {
        id: 'e1p.gateway.views.job-uwissues.Edit the Renewal if the customer is willing to accept the changes',
        defaultMessage: 'Edit the renewal if the customer is willing to accept the changes.'
    },
    editCancellation: {
        id: 'e1p.gateway.views.job-uwissues.Edit the Cancellation if the customer is willing to accept the changes',
        defaultMessage: 'Edit the cancellation if the customer is willing to accept the changes.'
    },
    withDrawIfYouWish: {
        id: 'e1p.gateway.views.job-uwissues.Withdraw if you do not wish to continue',
        defaultMessage: 'Withdraw if you do not wish to continue'
    },
    underwriterReviewingPolicyChange: {
        id: 'e1p.gateway.views.job-uwissues.This PolicyChange has been referred to an underwriter for review"',
        defaultMessage: 'This policy change has been referred to an underwriter for review.'
    },
    underwriterReviewingRenewal: {
        id: 'e1p.gateway.views.job-uwissues.This Renewal has been referred to an underwriter for review',
        defaultMessage: 'This renewal has been referred to an underwriter for review.'
    },
    underwriterReviewingSubmission: {
        id: 'e1p.gateway.views.job-uwissues.This Submission has been referred to an underwriter for review',
        defaultMessage: 'This quote has been referred to an underwriter for review.'
    },
    underwriterReviewingCancellation: {
        id: 'e1p.gateway.views.job-uwissues.This Cancellation has been referred to an underwriter for review',
        defaultMessage: 'This cancellation has been referred to an underwriter for review.'
    },
    stillWithdrawRenewal: {
        id: 'e1p.gateway.views.job-uwissues.You can still withdraw the renewal. If you decide not to, the underwriter will continue with the review process',
        defaultMessage: 'You can still withdraw the renewal. If you decide not to, the underwriter will continue with the review process'
    },
    reviewCompleteInfo: {
        id: 'e1p.gateway.views.job-uwissues.An activity will be created to inform you when the underwriter has completed the review',
        defaultMessage: 'An activity will be created to inform you when the underwriter has completed the review.'
    },
    withdrawPolicyChange: {
        id: 'e1p.gateway.views.job-uwissues.Withdraw PolicyChange',
        defaultMessage: 'Withdraw policy change'
    },
    withdrawRenewal: {
        id: 'e1p.gateway.views.job-uwissues.Withdraw Renewal',
        defaultMessage: 'Withdraw renewal'
    },
    withdrawRenewalWizard: {
        id: 'e1p.gateway.views.renewal.renewal-summary.You may either withdraw or continue to the renewal wizard.',
        defaultMessage: 'You may either withdraw or continue to the renewal wizard.'
    },
    continueRenewal: {
        id: 'e1p.gateway.views.job-uwissues.Continue Renewal',
        defaultMessage: 'Continue Renewal'
    },
    continuePolicyChange: {
        id: 'e1p.gateway.views.job-uwissues.PolicyChange',
        defaultMessage: 'Continue policy change'
    },
    continueSubmission: {
        id: 'e1p.gateway.views.job-uwissues.Continue Submission',
        defaultMessage: 'Continue quote'
    },
    continueCancellation: {
        id: 'e1p.gateway.views.job-uwissues.Continue Cancellation',
        defaultMessage: 'Continue cancellation'
    },
    withdrawSubmission: {
        id: 'e1p.gateway.views.job-uwissues.Withdraw Submission',
        defaultMessage: 'Withdraw quote'
    },
    withdrawCancellation: {
        id: 'e1p.gateway.views.job-uwissues.Withdraw Cancellation',
        defaultMessage: 'Withdraw cancellation'
    },
    rejectedByUW: {
        id: 'e1p.gateway.views.job-uwissues.One or more Underwriting issues have been rejected by the underwriter',
        defaultMessage: 'One or more Underwriting issues have been rejected by the underwriter'
    },
    offerUnresolvedIssue: {
        id: 'e1p.gateway.views.job-uwissues.Some offerings have unresolved underwriting issues',
        defaultMessage: 'Some offerings have unresolved underwriting issues.'
    },
    issueResolved: {
        id: 'e1p.gateway.views.job-uwissues.You can proceed with the offerings that do not have issues or where the issues have been resolved.',
        defaultMessage: 'You can proceed with the offerings that do not have issues or where the issues have been resolved.'
    },
    editOrReferPolicyChange: {
        id: 'e1p.gateway.views.job-uwissues.For offerings with unresolved issues you can either edit the PolicyChange or refer it to the Underwriter.',
        defaultMessage: 'For offerings with unresolved issues, you can either edit the policy change or refer it to the underwriter.'
    },
    editOrReferRenewal: {
        id: 'e1p.gateway.views.job-uwissues.For offerings with unresolved issues you can either edit the Renewal or refer it to the Underwriter.',
        defaultMessage: 'For offerings with unresolved issues, you can either edit the renewal or refer it to the underwriter.'
    },
    editOrReferSubmission: {
        id: 'e1p.gateway.views.job-uwissues.For offerings with unresolved issues you can either edit the Submission or refer it to the Underwriter.',
        defaultMessage: 'For offerings with unresolved issues, you can either edit the quote or refer it to the underwriter.'
    },
    editOrReferCancellation: {
        id: 'e1p.gateway.views.job-uwissues.For offerings with unresolved issues you can either edit the Cancellation or refer it to the Underwriter.',
        defaultMessage: 'For offerings with unresolved issues, you can either edit the cancellation or refer it to the underwriter.'
    },
    withdrawOrContinuePolicyChange: {
        id: 'e1p.gateway.views.job-uwissues.You may either withdraw or continue to the PolicyChange wizard',
        defaultMessage: 'You may either withdraw or continue to the policy change wizard.'
    },
    withdrawOrContinueRenewal: {
        id: 'e1p.gateway.views.job-uwissues.You may either withdraw or continue to the Renewal wizard',
        defaultMessage: 'You may either withdraw or continue to the renewal wizard.'
    },
    withdrawOrContinueSubmission: {
        id: 'e1p.gateway.views.job-uwissues.You may either withdraw or continue to the Submission wizard',
        defaultMessage: 'You may either withdraw or continue to the quote wizard.'
    },
    withdrawOrContinueCancellation: {
        id: 'e1p.gateway.views.job-uwissues.You may either withdraw or continue to the Cancellation wizard',
        defaultMessage: 'You may either withdraw or continue to the cancellation wizard.'
    },
    withdrawThePolicyChange: {
        id: 'e1p.gateway.views.job-uwissues.You may withdraw the PolicyChange',
        defaultMessage: 'You may withdraw the policy change'
    },
    withdrawTheRenewal: {
        id: 'e1p.gateway.views.job-uwissues.You may withdraw the Renewal',
        defaultMessage: 'You may withdraw the renewal'
    },
    withdrawTheQuote: {
        id: 'e1p.gateway.views.job-uwissues.You may withdraw the Submission',
        defaultMessage: 'You may withdraw the quote'
    },
    withdrawTheCancellation: {
        id: 'e1p.gateway.views.job-uwissues.You may withdraw the Cancellation',
        defaultMessage: 'You may withdraw the cancellation'
    },
    lockedPolicyChange: {
        id: 'e1p.gateway.views.job-uwissues.This PolicyChange is locked.',
        defaultMessage: 'This policy change is locked.'
    },
    lockedRenewal: {
        id: 'e1p.gateway.views.job-uwissues.This Renewal is locked.',
        defaultMessage: 'This renewal is locked.'
    },
    lockedSubmission: {
        id: 'e1p.gateway.views.job-uwissues.This Submission is locked.',
        defaultMessage: 'This quote is locked.'
    },
    lockedCancellation: {
        id: 'e1p.gateway.views.job-uwissues.This Cancellation is locked.',
        defaultMessage: 'This cancellation is locked.'
    },
    referralInfoPolicyChange: {
        id: 'e1p.gateway.views.job-uwissues.Referral Info for PolicyChange',
        defaultMessage: 'Once referred, a high priority activity will be created for the underwriter. You will not be able to edit the policy change until the underwriter releases it back to you.'
    },
    referralInfoRenewal: {
        id: 'e1p.gateway.views.job-uwissues.Referral Info for Renewal',
        defaultMessage: 'Once referred, a high priority activity will be created for the underwriter. You will not be able to edit the renewal until the underwriter releases it back to you.'
    },
    referralInfoSubmission: {
        id: 'e1p.gateway.views.job-uwissues.Referral Info for Submission',
        defaultMessage: 'Once referred, a high priority activity will be created for the underwriter. You will not be able to edit the quote until the underwriter releases it back to you.'
    },
    referralInfoCancellation: {
        id: 'e1p.gateway.views.job-uwissues.Referral Info for Cancellation',
        defaultMessage: 'Once referred, a high priority activity will be created for the underwriter. You will not be able to edit the cancellation until the underwriter releases it back to you.'
    },
    referToUWPolicyChange: {
        id: 'e1p.gateway.views.job-uwissues.Are you sure you want to refer this PolicyChange to the Underwriter?',
        defaultMessage: 'Are you sure you want to refer this policy change to the Underwriter?'
    },
    referToUWInfoRenewal: {
        id: 'e1p.gateway.views.job-uwissues.Are you sure you want to refer this Renewal to the Underwriter?',
        defaultMessage: 'Are you sure you want to refer this renewal to the Underwriter?'
    },
    referToUWSubmission: {
        id: 'e1p.gateway.views.job-uwissues.Are you sure you want to refer this Submission to the Underwriter?',
        defaultMessage: 'Are you sure you want to refer this quote to the Underwriter?'
    },
    referToUWCancellation: {
        id: 'e1p.gateway.views.job-uwissues.Are you sure you want to refer this Cancellation to the Underwriter?',
        defaultMessage: 'Are you sure you want to refer this cancellation to the Underwriter?'
    },
    referToUnderwriter: {
        id: 'e1p.gateway.views.job-uwissues.Refer to Underwriter',
        defaultMessage: 'Refer to Underwriter'
    },
    noteForUnderwriter: {
        id: 'e1p.gateway.views.job-uwissues.Note for the underwriter (optional)',
        defaultMessage: 'Note for Underwriter (optional)'
    },
    noteForUnderwriterWizard: {
        id: 'e1p.gateway.views.job-uwissues.Note for the underwriter',
        defaultMessage: 'Note for Underwriter'
    },
    moreInfoUW: {
        id: 'e1p.gateway.views.job-uwissues.For more information, please contact the underwriter.',
        defaultMessage: 'For more information, please contact the underwriter.'
    },
    approvedForThisCancellation: {
        id: 'e1p.gateway.views.job-uwissues.All underwriting issues have been approved for this Cancellation',
        defaultMessage: 'All underwriting issues have been approved for this cancellation.'
    },
    approvedForThisSubmission: {
        id: 'e1p.gateway.views.job-uwissues.All underwriting issues have been approved for this Submission',
        defaultMessage: 'All underwriting issues have been approved for this quote.'
    },
    approvedForThisRenewal: {
        id: 'e1p.gateway.views.job-uwissues.All underwriting issues have been approved for this Renewal',
        defaultMessage: 'All underwriting issues have been approved for this renewal.'
    },
    approvedForThisPolicyChange: {
        id: 'e1p.gateway.views.job-uwissues.All underwriting issues have been approved for this PolicyChange',
        defaultMessage: 'All underwriting issues have been approved for this policy change.'
    },
    approved: {
        id: 'e1p.gateway.views.job-uwissues.Approved',
        defaultMessage: 'Approved'
    },
    errorSendingJobForReview: {
        id: 'e1p.gateway.views.job-uwissues.There was an error sending the job for review',
        defaultMessage: 'There was an error sending the job for review.'
    },
    notApplicable: {
        id: 'e1p.gateway.views.job-uwissues.N/A',
        defaultMessage: 'N/A'
    }
});
